module.exports = __webpack_public_path__ + "static/media/SAINT_6620.2432624f.jpg";